import { Message, MessageBox } from 'element-ui';

const errMsg = {
  400: '请求参数错误',
  404: '请求资源不存在',
  500: '服务开小差了，请稍后',
  1012: '注册审批未通过',
  3001: '用户不存在',
  3007: '无法删除第一个用户',
  3002: '账户不存在或密码不正确',
  2001: '短信验证码不正确',
  1008: '企业账户审核中、请稍后登录',
  2005: '短信验证码超时',
  3004: '用户电话号码已存在',
  3003: '用户邮箱已存在',
  6016: '当前企业没有进行实名认证、认证完成即可购买',
  10027: '应用处于上架状态，唯一套餐不能删除，请先下架应用',
  24001: '交付环境不可用，请确认输入信息正确',
  24000: '交付环境已存在',
  10025: '应用无有效的套餐，不能上架',
  40301: '无权进行此操作，请联系企业管理员授予权限',
  10031: '私有应用，不能上架',
  14031: '信息不存在',
  10032: '应用版本号已存在',
  10020: '应用版本不存在',
  20004: '应用已释放',
  1009: '该企业已经完成实名认证',
  10021: '客户已存在',
  10029: '客户不存在',
  12004: '角色已存在',
  10014: '商店域名已存在',
  40302: '企业已禁用，不能登录',
  10035: '商店名称已存在',
  10000: '商店已存在',
  23002: '域名已被使用，请更换域名',
  1020: '请求超时，请重试',
  10019: '商店已关闭,请联系平台客服',
  10037: '商店域名不能与当前企业域名相同',
  1011: '无法删除最后一个管理员',
  3000: '用户已经存在',
  1010: '默认管理员角色不能删除',
  10002: '套餐指标标识重复',
  20006: '交付应用所处状态不能进行重新交付',
  10038: '上首页申请暂只支持申请一次',
  6004: '访问订单不存在',
  2002: '验证码有误',
  10039: '至少有一个启用的套餐',
  10041: '上架的应用至少有一个启用套餐',
  10040: '至少有一个套餐'
};
export function errorHandle(err, callback) {
  const msg = (err.code && errMsg[err.code]) || err.msg;

  if (err.code && err.code == 10019) {
    MessageBox({
      title: '平台提示',
      type: 'warning',
      message: msg
    });
    return;
  }
  if (callback) {
    callback(msg);
    return;
  }
  Message({
    message: msg,
    type: 'warning',
    duration: 3 * 1000
  });
}



// WEBPACK FOOTER //
// ./src/utils/error.js